import { Translatable } from "@icc/shared/helpers";

/** Rodzaj moskitiery rolety zewnętrznej */
export class RollerMosquitoScreenType {
    id: string;
    originalId: number;
    /** Typ moskitiery
     * 'accessory' - moskitiera rolowana
     * 'montage_type' - moskitiera plisowana
     */
    type: 'accessory' | 'montage_type';
    /** Kod zewnętrzny */
    extId: string | null;
    /** Kod do indeksu */
    indexNo: string | null;
    /** Nazwa */
    @Translatable({ model: 'WindowAccessories', idField: 'originalId' })
    name: string;
    /** Minimalna szerokość */
    minWidth: number;
    /** Maksymalna szerokość */
    maxWidth: number;
    /** Minimalna wysokość */
    minHeight: number;
    /** Maksymalna wysokość */
    maxHeight: number;

    /** Minimalna szerokość z hamulcem */
    minWidthWithBrake: number;
    /** Minimalna wysokość z hamulcem */
    minHeightWithBrake: number;
    /** Maksymalna szerokość z hamulcem */
    maxWidthWithBrake: number;
    /** Maksymalna wysokość z hamulcem */
    maxHeightWithBrake: number;

    /** Przypisane typy produktów */
    shutterTypesIds?: number[];
    /** Grupa typu produktu rolety (dla moskitier plisowanych) */
    shutterTypeGroupId?: number;
    /** Kolejność */
    order?: number;
    /** Czy moskitiera jest zintegrowana z prowadnicami */
    integratedWithGuides?: boolean;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
    /** Typy produktów moskitier */
    shutterTypes?: {
        id: number;
        name: string;
        /** Zakres rozmiarów */
        sizeRangeId?: number;
    }[];
}
